(function () {
  function titleCase(str) {
    if (!str) return '';
    return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
  }

  function initEstimator(widget) {
    const sectionId = widget.dataset.sectionId;
    const dataEl = document.getElementById(`DropshipVariantData-${sectionId}`);
    if (!dataEl) return;

    const { variants, vendor, workerUrl } = JSON.parse(dataEl.textContent);

    const form = widget.querySelector('.stock-availability-form');
    const input = widget.querySelector('.stock-availability-input');
    const inputWrapper = widget.querySelector('.stock-availability-input-wrapper');
    const button = widget.querySelector('.stock-availability-button');
    const results = widget.querySelector('.dropship-estimator__results');
    const dot = widget.querySelector('[data-option-type="delivery"] .stock-option-dot');
    const title = widget.querySelector('[data-option-type="delivery"] .stock-option-title');
    const feeRow = widget.querySelector('[data-option-type="delivery-fee"]');
    const feeTitle = feeRow && feeRow.querySelector('.stock-option-title');
    const ctaEl = widget.querySelector('.dropship-info-cta');

    results.style.display = 'none';

    let currentVariantId = parseInt(widget.dataset.selectedVariant, 10);
    let currentSuburb = null;
    let suburbDropdown = null;

    function getVariantData(id) {
      return variants.find(v => v.id === id) || null;
    }

    // ── Error / validation ───────────────────────────────────────────────────

    function showInputError(msg) {
      clearInputError();
      const err = document.createElement('div');
      err.className = 'dropship-estimator__input-error';
      err.style.cssText = 'font-size:1.2rem;color:#cc0000;margin-top:0.4rem;';
      err.textContent = msg;
      form.insertAdjacentElement('afterend', err);
    }

    function clearInputError() {
      const existing = widget.querySelector('.dropship-estimator__input-error');
      if (existing) existing.remove();
    }

    // ── Suburb dropdown ──────────────────────────────────────────────────────

    function removeSuburbDropdown() {
      if (suburbDropdown) {
        suburbDropdown.remove();
        suburbDropdown = null;
      }
    }

    function showSuburbDropdown(matches, postcode) {
      removeSuburbDropdown();

      const dropdown = document.createElement('div');
      dropdown.className = 'suburb-dropdown';
      dropdown.style.cssText = `
        border: 1px solid rgba(var(--color-foreground), 0.1);
        border-radius: 0.4rem;
        margin-top: 0.5rem;
        overflow-y: auto;
        max-height: 18rem;
        background: rgb(var(--color-background));
      `;

      matches.forEach(match => {
        const item = document.createElement('div');
        item.className = 'suburb-dropdown-item';
        item.style.cssText = `
          padding: 1rem 1.2rem;
          cursor: pointer;
          font-size: 1.4rem;
          border-bottom: 1px solid rgba(var(--color-foreground), 0.06);
          display: flex;
          justify-content: space-between;
          align-items: center;
        `;
        item.innerHTML = `
          <span>${titleCase(match.Suburb)}</span>
          <span style="color:rgba(var(--color-foreground),0.5);font-size:1.2rem;">${match.State} ${match.Postocode}</span>
        `;
        item.addEventListener('mouseenter', () => {
          item.style.backgroundColor = 'rgba(var(--color-foreground), 0.04)';
        });
        item.addEventListener('mouseleave', () => {
          item.style.backgroundColor = '';
        });
        item.addEventListener('click', () => {
          input.value = `${titleCase(match.Suburb)}, ${match.State} ${match.Postocode}`;
          removeSuburbDropdown();
          check(match.Postocode, titleCase(match.Suburb));
        });
        dropdown.appendChild(item);
      });

      form.parentNode.insertBefore(dropdown, form.nextSibling);
      suburbDropdown = dropdown;
    }

    // ── Results display ──────────────────────────────────────────────────────

    function showResults() {
      results.style.display = 'block';
      results.classList.add('visible');
    }

    function setLoading(on) {
      widget.classList.toggle('loading', on);
    }

    const SVG_TRUCK = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M15 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17h-2v-11a1 1 0 0 1 1-1h9v12m-4 0h6m4 0h2v-6h-8m0-5h5l3 5"/></svg>`;
    const SVG_STORE = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 21l18 0"/><path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2-4h14l2 4"/><path d="M5 21l0-10.15"/><path d="M19 21l0-10.15"/><path d="M9 21v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4"/></svg>`;

    function setResult(serviceable, rate, free, postcode) {
      setLoading(false);
      showResults();
      dot.classList.toggle('available', serviceable);

      if (!serviceable) {
        const location = currentSuburb ? `${currentSuburb} ${postcode}` : postcode;
        title.textContent = `Delivery is not available to ${location}.`;
        title.style.color = '#cc0000';
        if (feeRow) feeRow.style.display = 'none';
        if (ctaEl) {
          ctaEl.innerHTML = `${SVG_STORE}<span>Please contact your nearest store for delivery enquiries.</span>`;
          ctaEl.style.display = '';
        }
        return;
      }

      title.textContent = (free || !rate)
        ? 'Free delivery available to your postcode.'
        : 'Delivery available to your postcode.';
      title.style.color = '';

      if (ctaEl) {
        ctaEl.innerHTML = `${SVG_TRUCK}<span>Delivered directly from our supplier to your door.</span>`;
        ctaEl.style.display = '';
      }

      if (free || !rate) {
        if (feeRow) feeRow.style.display = 'none';
      } else {
        const dollars = (rate / 100).toFixed(2);
        if (feeRow && feeTitle) {
          feeTitle.textContent = `Delivery Fee: $${dollars}`;
          feeRow.style.display = '';
        }
      }
    }

    function setError() {
      setLoading(false);
      showResults();
      dot.classList.remove('available');
      title.textContent = 'Unable to check delivery. Please try again.';
      title.style.color = 'rgba(var(--color-foreground), 0.6)';
      if (feeRow) feeRow.style.display = 'none';
      if (ctaEl) ctaEl.style.display = 'none';
    }

    // ── Worker call ──────────────────────────────────────────────────────────

    async function check(postcode, suburb) {
      if (suburb) currentSuburb = suburb;
      const variantData = getVariantData(currentVariantId);
      if (!variantData) return;

      const body = {
        postcode,
        vendor,
        sku: variantData.sku,
        rate_category: variantData.rate_category,
      };

      setLoading(true);
      showResults();

      try {
        const res = await fetch(workerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setResult(data.serviceable, data.rate, data.free, postcode);
      } catch {
        setError();
      }
    }

    // ── Form submit ──────────────────────────────────────────────────────────

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      clearInputError();
      removeSuburbDropdown();

      const raw = input.value.trim();
      const postcode = raw.replace(/\D/g, '').slice(0, 4);

      if (!/^\d{4}$/.test(postcode)) {
        showInputError('Please enter a valid 4-digit postcode');
        return;
      }

      button.disabled = true;

      try {
        if (!window.omfGeo) throw new Error('Location service unavailable. Please refresh and try again.');

        const matches = await window.omfGeo.getPostcodeMatches(postcode);

        if (!matches || matches.length === 0) {
          showInputError('Postcode not found. Please check and try again.');
          return;
        }

        if (matches.length === 1) {
          check(postcode, titleCase(matches[0].Suburb));
        } else {
          showSuburbDropdown(matches, postcode);
        }
      } catch (err) {
        showInputError(err.message || 'Something went wrong. Please try again.');
      } finally {
        button.disabled = false;
      }
    });

    input.addEventListener('input', () => {
      clearInputError();
      removeSuburbDropdown();
    });

    // ── Variant change ───────────────────────────────────────────────────────

    document.addEventListener('variant:changed', (e) => {
      const detail = e.detail || {};
      if (detail.sectionId && detail.sectionId !== sectionId) return;
      if (detail.variant) {
        currentVariantId = detail.variant.id;
        widget.dataset.selectedVariant = currentVariantId;
        // Re-check if a postcode is already entered
        const raw = input.value.trim();
        const postcode = raw.replace(/\D/g, '').slice(0, 4);
        if (/^\d{4}$/.test(postcode)) check(postcode);
      }
    });
  }

  function init() {
    document.querySelectorAll('.dropship-estimator').forEach(initEstimator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
